import { PHONE_NUMBER_RULES } from "./Constants";

export const emailValidation = (email) => {
  // expected email format tanya@abc.xyz
  const emailPattern = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,6}$/;
  let valid = false;
  if (!emailPattern.test(email)) {
    valid = false;
  } else {
    valid = true;
  }
  return valid;
};

export const passwordValidation = (password) => {
  // password validation requires 8 digits, one Uppercase, one lowercase, one special character and one digit
  const passwordPattern =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  let valid = false;
  if (!passwordPattern.test(password)) {
    valid = false;
  } else {
    valid = true;
  }
  return valid;
};

export const nameValidation = (password) => {
  // password validation requires 8 digits, one Uppercase, one lowercase, one special character and one digit
  const namePattern = /^[A-Za-z][A-Za-z'-\s]{1,49}[A-Za-z]$/;
  let valid = false;
  if (!namePattern.test(password) || namePattern.length < 3) {
    valid = false;
  } else {
    valid = true;
  }
  return valid;
};

export const assistantNameValidation = (name) => {
  // Name validation allows 3-50 characters: letters, apostrophes, hyphens, spaces, and dots
  // const namePattern = /^[A-Za-z][A-Za-z.'-\s]{1,49}[A-Za-z.]$/;
  let valid = false;
  if (name.length < 3) {
    valid = false;
  } else {
    valid = true;
  }
  return valid;
};

export const nameWithNumberValidation = (name) => {
  // Name validation: allows letters, numbers, spaces, hyphens, and apostrophes
  const namePattern = /^[a-zA-Z0-9\s'-]+$/;
  let valid = false;
  if (!namePattern.test(name) || name.length < 3) {
    valid = false;
  } else {
    valid = true;
  }
  return valid;
};

export const validURL = (str) => {
  const pattern = new RegExp(
    /^(https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:\d+)?(\/.*)?$/
  );
  return pattern.test(str);
};
export const validWidgetWebsiteURL = (str) => {
  const pattern = new RegExp(
    /^((https?:\/\/)?((localhost|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|\d{1,3}(\.\d{1,3}){3})))(:\d+)?(\/.*)?$/
  );
  return pattern.test(str);
};

export const phoneNumberValidation = (phoneNumber, callingCode = "+61") => {
  const updatedPhNo = phoneNumber.replace(/\D/g, ""); // Remove non-numeric characters
  let valid = false;

  const pattern =
    /^(\d)\1*$|(?:012345|123456|234567|345678|456789|567890|678901|789012|890123|901234|987654|876543|765432|654321|543210)$/;

  if (RegExp("^[0-9]*$").test(updatedPhNo)) {
    if (!pattern.test(updatedPhNo)) {
      const maxMinDigits = getPhoneNumberLimits(callingCode);
      const minDigits = maxMinDigits?.min;
      const maxDigits = maxMinDigits?.max;
      valid = updatedPhNo.length >= minDigits && updatedPhNo.length <= maxDigits;
    }
  }
  return valid;
};

export const phoneNumberFormat = (phoneNumber) => {
  const newphoneNumber = phoneNumber.replace(/\D/g, "");
  const formatted =
    newphoneNumber.length == 0
      ? newphoneNumber
      : newphoneNumber.length < 4
      ? "(" + newphoneNumber
      : newphoneNumber.length < 7
      ? "(" +
        newphoneNumber.substring(0, 3) +
        ") " +
        newphoneNumber.substring(3, 6)
      : "(" +
        newphoneNumber.substring(0, 3) +
        ") " +
        newphoneNumber.substring(3, 6) +
        " - " +
        newphoneNumber.substring(6, 10);
  return formatted;
};

export const phoneNumberFormatter = (phoneNumber, countryCallingCode) => {
  if (phoneNumber === "") {
    return "";
  }
  if (countryCallingCode === "+61") {
    return phoneNumberFormatAu(phoneNumber); // Australia
  } else if (countryCallingCode === "+64") {
    return phoneNumberFormatNz(phoneNumber); // New Zealand
  } else {
    return phoneNumberFormat(phoneNumber); // Generic
  }
};

export const phoneNumberFormatAu = (phoneNumber) => {
  const newphoneNumber = phoneNumber.replace(/\D/g, ""); // Remove non-numeric characters

  // Ensure we allow 9-10 digits for mobiles and landlines
  if (newphoneNumber.startsWith("4")) {
    // Mobile format: 4XX XXX XXX
    const formatted =
      newphoneNumber.length < 4
        ? newphoneNumber
        : newphoneNumber.length < 7
        ? `${newphoneNumber.slice(0, 3)} ${newphoneNumber.slice(3, 6)}`
        : `${newphoneNumber.slice(0, 3)} ${newphoneNumber.slice(
            3,
            6
          )} ${newphoneNumber.slice(6)}`; // Keep all digits
    return formatted;
  } else {
    // Landline format: X XXXX XXXX
    const formatted =
      newphoneNumber.length < 2
        ? newphoneNumber
        : newphoneNumber.length < 6
        ? `${newphoneNumber.slice(0, 1)} ${newphoneNumber.slice(1, 5)}`
        : `${newphoneNumber.slice(0, 1)} ${newphoneNumber.slice(
            1,
            5
          )} ${newphoneNumber.slice(5)}`; // Keep all digits
    return formatted;
  }
};

// Format for New Zealand numbers (+64)
export const phoneNumberFormatNz = (phoneNumber) => {
  const newphoneNumber = phoneNumber.replace(/\D/g, ""); // Remove non-numeric characters

  // Ensure we allow 7-10 digits for mobiles and landlines
  if (newphoneNumber.length === 0) {
    return ""; // If there's no input, return empty
  }

  let formatted = "";

  if (newphoneNumber.length < 3) {
    formatted = newphoneNumber; // If fewer than 3 digits, just return the digits
  } else if (newphoneNumber.length < 6) {
    // Format for 2-digit area code and 3-digit local number
    formatted = `${newphoneNumber.slice(0, 2)} ${newphoneNumber.slice(2)}`;
  } else if (newphoneNumber.length < 9) {
    // Format for 2-digit area code and 3-digit, 3-digit local number
    formatted = `${newphoneNumber.slice(0, 2)} ${newphoneNumber.slice(
      2,
      5
    )} ${newphoneNumber.slice(5)}`;
  } else {
    // Format for 4-digit local numbers and a total of 10 digits
    formatted = `${newphoneNumber.slice(0, 4)} ${newphoneNumber.slice(
      4,
      7
    )} ${newphoneNumber.slice(7, 10)}`;
  }

  return formatted;
};

export function getPhoneNumberLimits(countryCode) {
  return PHONE_NUMBER_RULES[countryCode] || { min: 10, max: 10 };
}
export const handlePhoneNoChange = (
  e,
  countryCallingCode,
  setFormData,
  setFormError,
  setHasChanged,
  isChangedCursor = true
) => {
  let value = `${e?.target?.value ?? ""}`;
  value = value.trim().replace(/\D/g, "");
  let input = e.target;

  // Get the raw digits (without any formatting) from the current input value
  const rawDigitsBefore = value.replace(/\D/g, "");

  // Get the current cursor position in the input
  const cursorPosition = e.target.selectionStart;

  // Set digit limits for Australia (+61) and New Zealand (+64)
  const maxMinDigits = getPhoneNumberLimits(countryCallingCode);
  const minDigits = maxMinDigits?.min;
  const maxDigits = maxMinDigits?.max;

  // Prevent more than the allowed maximum number of digits
  if (rawDigitsBefore.length > maxDigits) {
    return; // Exit early if more than max digits
  }
  if (typeof setHasChanged == "function") {
    setHasChanged(true);
  }

  // Calculate the number of digits before the cursor (to maintain position after formatting)
  let digitsBeforeCursor = 0;
  for (let i = 0; i < cursorPosition; i++) {
    if (/\d/.test(value[i])) {
      digitsBeforeCursor++;
    }
  }

  // Format the phone number based on country code
  let formatted = phoneNumberFormatter(value, countryCallingCode);

  // Get the raw digits from the formatted phone number
  const rawDigitsAfter = formatted.replace(/\D/g, "");

  // Calculate the new cursor position based on the updated digits count
  let newCursorPosition = 0;
  let digitsCount = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      digitsCount++;
    }
    if (digitsCount === digitsBeforeCursor) {
      newCursorPosition = i + 1; // Set the cursor position just after the last matching digit
      break;
    }
  }

  // Update the form data with the formatted value
  if (typeof setFormData == "function") {
    setFormData(formatted);
  }

  // Set the cursor to the new position after the formatting
  setTimeout(() => {
    if (isChangedCursor) {
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    }
  }, 0);

  // Phone number validation
  const isValid = phoneNumberValidation(rawDigitsAfter, countryCallingCode);

  const phoneError =
    isValid || value === ""
      ? ""
      : rawDigitsBefore.length < minDigits
      ? `Phone number must be at least ${minDigits} digits long.`
      : "Please enter a valid phone number";

  if (typeof setFormData == "function") {
    setFormError(phoneError);
  }
  return {
    formatted,
    phoneError,
  };
};
